import request from './fetch';

// add new project
export function addNewProject (data = {}) {
  return request({
    url: '/v1/check_planogram',
    method: 'POST',
    data: data,
  });
}

// add new layout for project
/**
 * 
 * @param {
 * projectid,
 * is_share,
 * rows,
 * columns
 * } data 
 * @returns 
 */
export function addNewLayout (data = {}) {
  return request({
    url: '/v1/check_layout',
    method: 'POST', 
    data: data,
  });
}

export function getAllImgByProId (id, gallery= false) {
  return request({
    url: `/v1/check_planogram/${id}?gallery=${gallery}`,
    method: 'GET',
  });
} 

export function getAllProjects (isShare, page) {
  return request({
    url: `/v1/check_planogram?page_size=100&page=${page}` + (isShare ? '&is_share=1' : ''),
    method: 'GET',
  });
}

export function uploadImg (data) {
  return request({
    url: '/v1/segmentation',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data'},
    data: data,
  });
}

export function putImgToProject (projectid, data) {
  return request({
    url: `/v1/check_planogram/${projectid}`,
    method: 'PUT',
    data: data,
  });
}

export function delProjectImg (projectid, data) {
  return request({
    url: `/v1/check_planogram/${projectid}`,
    method: 'DELETE',
    data: data,
  });
}

export function previewLayout (data) {
  return request({
    url: '/v1/preview_layout',
    method: 'POST',
    data: data,
  });
}

export function checkLayout (layoutId, data) {
  return request({
    url: '/v1/check_layout/' + layoutId,
    method: 'PUT',
    headers: { 'Content-Type': 'application/octet-stream'},
    data: data,
  });
}

export function runCheckLayout (data) {
  return request({
    url: '/v1/check_layout_run',
    method: 'POST',
    data: data
  });
}

export function getCheckLayoutResult (id) {
  return request({
    url: `/v1/check_layout/${id}`,
    method: 'GET',
  });
}

export function getPredPackage (isShare = false, page) {
  return request({
    url: `/v1/pred_package?page_size=10&page=${page}` + (isShare ? '&is_share=1' : ''),
    method: 'GET',
  });
}

export function transferimageToPlanogram (id) {
  return request({
    url: '/v1/transferimage/' + id,
    method: 'GET',
  });
}

export function getImgUrl(fileKey) {
  return request({
    url: '/v1/azure_file?file_key=' + fileKey,
    method: 'put'
  });
}

export function getImageurl(data) {
  return request({
    url: '/v1/imageurl',
    method: 'POST',
    data: data,
  });
}